import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  addCustomRiskPopup: {
    "& .MuiDialog-paper": {
      height: 590
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      "& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root":
        {
          paddingLeft: 18,
          paddingRight: 18
        },
      "& .MuiDialogActions-root": {
        justifyContent: "space-between"
      }
    }
  },
  fieldGroupTitle: {
    fontSize: 18,
    marginBottom: 8,
    [theme.breakpoints.down(Breakpoints.XS_420)]: {
      fontSize: 16
    }
  },
  formField: {
    display: "flex",
    marginBottom: 8,
    "& .MuiInputBase-root": {
      boxShadow: "0 0 20px 12px rgba(0, 0, 0, 0.06)",
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        "& input": {
          height: 34
        }
      },
      [theme.breakpoints.down(Breakpoints.SS_320)]: {
        "& input": {
          height: 32
        }
      }
    }
  },
  riskDetailsContainer: {
    margin: "8px 0 32px"
  },
  riskScoreContainer: {
    marginTop: 16,
    display: "flex",
    justifyContent: "space-between"
  },
  riskScoreButton: {
    width: 43,
    minWidth: 43,
    height: 48,
    fontWeight: 600,
    "&.selected": {
      background: "#489B77",
      color: "#fff"
    },
    [theme.breakpoints.down(Breakpoints.XS_420)]: {
      width: 30,
      minWidth: 30,
      height: 34
    },
    [theme.breakpoints.down(Breakpoints.SS_320)]: {
      width: 24,
      minWidth: 24,
      height: 30,
      fontSize: 12,
      "&.MuiButton-outlined": {
        paddingLeft: 12,
        paddingRight: 12
      }
    }
  }
}));
